import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { createAction } from '/@/store/utils';

export const getStackUntil = (view, stack) => {
    const limit = stack.findIndex(({ id }) => id === view.id);
    return [...stack.slice(0, limit), view];
};

const mailto = (subject = '') => {
    subject = window.encodeURIComponent(subject);
    return window.open(`mailto:${settings.app.infoEmail}?subject=${subject}`);
};

export const openMenu = createAction('NAV:OPEN_MENU');
export const closeMenu = createAction('NAV:CLOSE_MENU');
export const closeMenuFromOverlay = createAction('NAV:CLOSE_MENU_FROM_OVERLAY');
export const closeMenuFromIcon = createAction('NAV:CLOSE_MENU_FROM_ICON');
export const clickMenu = createAction('NAV:CLICK_MENU');
export const openPopup = createAction('NAV:OPEN_POPUP');
export const closePopup = createAction('NAV:CLOSE_POPUP');

export const setView = createAction('NAV:SET_VIEW');

export const setShowTermsAndConditions = createAction('NAV:SHOW_TERMS_AND_CONDITIONS');

export const trackEvent = createAction('TRACK_EVENT');

export const setSelectedFeature = createAction('NAV:SET_SELECTED_FEATURE');

export const emailSupport = createAction('NAV:EMAIL_SUPPORT', () => mailto(_('Soporte técnico')));
export const emailExpert = createAction('NAV:EMAIL_EXPERT', () => mailto(_('Consulta a experto')));

export const setGoBack = createAction('NAV:GO_BACK');
